"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.statesList = void 0;
exports.statesList = {
    '': { '': { iso2: '', label: '', value: '' } },
    US: {
        alabama: { iso2: 'AL', label: 'Alabama', value: 'Alabama' },
        al: { iso2: 'AL', label: 'Alabama', value: 'Alabama' },
        alaska: { iso2: 'AK', label: 'Alaska', value: 'Alaska' },
        ak: { iso2: 'AK', label: 'Alaska', value: 'Alaska' },
        arizona: { iso2: 'AZ', label: 'Arizona', value: 'Arizona' },
        az: { iso2: 'AZ', label: 'Arizona', value: 'Arizona' },
        arkansas: { iso2: 'AR', label: 'Arkansas', value: 'Arkansas' },
        ar: { iso2: 'AR', label: 'Arkansas', value: 'Arkansas' },
        california: { iso2: 'CA', label: 'California', value: 'California' },
        ca: { iso2: 'CA', label: 'California', value: 'California' },
        colorado: { iso2: 'CO', label: 'Colorado', value: 'Colorado' },
        co: { iso2: 'CO', label: 'Colorado', value: 'Colorado' },
        connecticut: { iso2: 'CT', label: 'Connecticut', value: 'Connecticut' },
        ct: { iso2: 'CT', label: 'Connecticut', value: 'Connecticut' },
        delaware: { iso2: 'DE', label: 'Delaware', value: 'Delaware' },
        de: { iso2: 'DE', label: 'Delaware', value: 'Delaware' },
        florida: { iso2: 'FL', label: 'Florida', value: 'Florida' },
        fl: { iso2: 'FL', label: 'Florida', value: 'Florida' },
        georgia: { iso2: 'GA', label: 'Georgia', value: 'Georgia' },
        ga: { iso2: 'GA', label: 'Georgia', value: 'Georgia' },
        hawaii: { iso2: 'HI', label: 'Hawaii', value: 'Hawaii' },
        hi: { iso2: 'HI', label: 'Hawaii', value: 'Hawaii' },
        idaho: { iso2: 'ID', label: 'Idaho', value: 'Idaho' },
        id: { iso2: 'ID', label: 'Idaho', value: 'Idaho' },
        illinois: { iso2: 'IL', label: 'Illinois', value: 'Illinois' },
        il: { iso2: 'IL', label: 'Illinois', value: 'Illinois' },
        indiana: { iso2: 'IN', label: 'Indiana', value: 'Indiana' },
        in: { iso2: 'IN', label: 'Indiana', value: 'Indiana' },
        iowa: { iso2: 'IA', label: 'Iowa', value: 'Iowa' },
        ia: { iso2: 'IA', label: 'Iowa', value: 'Iowa' },
        kansas: { iso2: 'KS', label: 'Kansas', value: 'Kansas' },
        ks: { iso2: 'KS', label: 'Kansas', value: 'Kansas' },
        kentucky: { iso2: 'KY', label: 'Kentucky', value: 'Kentucky' },
        ky: { iso2: 'KY', label: 'Kentucky', value: 'Kentucky' },
        louisiana: { iso2: 'LA', label: 'Louisiana', value: 'Louisiana' },
        la: { iso2: 'LA', label: 'Louisiana', value: 'Louisiana' },
        maine: { iso2: 'ME', label: 'Maine', value: 'Maine' },
        me: { iso2: 'ME', label: 'Maine', value: 'Maine' },
        maryland: { iso2: 'MD', label: 'Maryland', value: 'Maryland' },
        md: { iso2: 'MD', label: 'Maryland', value: 'Maryland' },
        massachusetts: { iso2: 'MA', label: 'Massachusetts', value: 'Massachusetts' },
        ma: { iso2: 'MA', label: 'Massachusetts', value: 'Massachusetts' },
        michigan: { iso2: 'MI', label: 'Michigan', value: 'Michigan' },
        mi: { iso2: 'MI', label: 'Michigan', value: 'Michigan' },
        minnesota: { iso2: 'MN', label: 'Minnesota', value: 'Minnesota' },
        mn: { iso2: 'MN', label: 'Minnesota', value: 'Minnesota' },
        mississippi: { iso2: 'MS', label: 'Mississippi', value: 'Mississippi' },
        mp: { iso2: 'MS', label: 'Mississippi', value: 'Mississippi' },
        missouri: { iso2: 'MO', label: 'Missouri', value: 'Missouri' },
        mo: { iso2: 'MO', label: 'Missouri', value: 'Missouri' },
        montana: { iso2: 'MT', label: 'Montana', value: 'Montana' },
        mt: { iso2: 'MT', label: 'Montana', value: 'Montana' },
        nebraska: { iso2: 'NE', label: 'Nebraska', value: 'Nebraska' },
        ne: { iso2: 'NE', label: 'Nebraska', value: 'Nebraska' },
        nevada: { iso2: 'NV', label: 'Nevada', value: 'Nevada' },
        nv: { iso2: 'NV', label: 'Nevada', value: 'Nevada' },
        'new hampshire': { iso2: 'NH', label: 'New Hampshire', value: 'New Hampshire' },
        nh: { iso2: 'NH', label: 'New Hampshire', value: 'New Hampshire' },
        'new jersey': { iso2: 'NJ', label: 'New Jersey', value: 'New Jersey' },
        nj: { iso2: 'NJ', label: 'New Jersey', value: 'New Jersey' },
        'new mexico': { iso2: 'NM', label: 'New Mexico', value: 'New Mexico' },
        nm: { iso2: 'NM', label: 'New Mexico', value: 'New Mexico' },
        'new york': { iso2: 'NY', label: 'New York', value: 'New York' },
        ny: { iso2: 'NY', label: 'New York', value: 'New York' },
        'north carolina': { iso2: 'NC', label: 'North Carolina', value: 'North Carolina' },
        nc: { iso2: 'NC', label: 'North Carolina', value: 'North Carolina' },
        'north dakota': { iso2: 'ND', label: 'North Dakota', value: 'North Dakota' },
        nd: { iso2: 'ND', label: 'North Dakota', value: 'North Dakota' },
        ohio: { iso2: 'OH', label: 'Ohio', value: 'Ohio' },
        oh: { iso2: 'OH', label: 'Ohio', value: 'Ohio' },
        oklahoma: { iso2: 'OK', label: 'Oklahoma', value: 'Oklahoma' },
        ok: { iso2: 'OK', label: 'Oklahoma', value: 'Oklahoma' },
        oregon: { iso2: 'OR', label: 'Oregon', value: 'Oregon' },
        or: { iso2: 'OR', label: 'Oregon', value: 'Oregon' },
        pennsylvania: { iso2: 'PA', label: 'Pennsylvania', value: 'Pennsylvania' },
        pa: { iso2: 'PA', label: 'Pennsylvania', value: 'Pennsylvania' },
        'rhode island': { iso2: 'RI', label: 'Rhode Island', value: 'Rhode Island' },
        ri: { iso2: 'RI', label: 'Rhode Island', value: 'Rhode Island' },
        'south carolina': { iso2: 'SC', label: 'South Carolina', value: 'South Carolina' },
        sc: { iso2: 'SC', label: 'South Carolina', value: 'South Carolina' },
        'south dakota': { iso2: 'SD', label: 'South Dakota', value: 'South Dakota' },
        sd: { iso2: 'SD', label: 'South Dakota', value: 'South Dakota' },
        tennessee: { iso2: 'TN', label: 'Tennessee', value: 'Tennessee' },
        tn: { iso2: 'TN', label: 'Tennessee', value: 'Tennessee' },
        texas: { iso2: 'TX', label: 'Texas', value: 'Texas' },
        tx: { iso2: 'TX', label: 'Texas', value: 'Texas' },
        utah: { iso2: 'UT', label: 'Utah', value: 'Utah' },
        ut: { iso2: 'UT', label: 'Utah', value: 'Utah' },
        vermont: { iso2: 'VT', label: 'Vermont', value: 'Vermont' },
        vt: { iso2: 'VT', label: 'Vermont', value: 'Vermont' },
        virginia: { iso2: 'VA', label: 'Virginia', value: 'Virginia' },
        vi: { iso2: 'VI', label: 'Virgin Islands', value: 'Virgin Islands' },
        'virgin islands': { iso2: 'VI', label: 'Virgin Islands', value: 'Virgin Islands' },
        va: { iso2: 'VA', label: 'Virginia', value: 'Virginia' },
        washington: { iso2: 'WA', label: 'Washington', value: 'Washington' },
        wa: { iso2: 'WA', label: 'Washington', value: 'Washington' },
        'washington, d.c.': {
            iso2: 'DC',
            label: 'Washington, D.C.',
            value: 'Washington, D.C.'
        },
        dc: {
            iso2: 'DC',
            label: 'Washington, D.C.',
            value: 'Washington, D.C.'
        },
        'west virginia': { iso2: 'WV', label: 'West Virginia', value: 'West Virginia' },
        wv: { iso2: 'WV', label: 'West Virginia', value: 'West Virginia' },
        wisconsin: { iso2: 'WI', label: 'Wisconsin', value: 'Wisconsin' },
        wi: { iso2: 'WI', label: 'Wisconsin', value: 'Wisconsin' },
        wyoming: { iso2: 'WY', label: 'Wyoming', value: 'Wyoming' },
        wy: { iso2: 'WY', label: 'Wyoming', value: 'Wyoming' }
    }
};
//# sourceMappingURL=statesList.js.map